import { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { stringFormattingToCurrency } from "js/formatting";
import { isOldAlicUlPolicy } from "js/utilities";
import FormInputError from "components/General/FormInputError";

export default function PaymentAmount({
  panelTwoSelection,
  setPanelTwoSelection,
  selected,
  register,
  setValue,
  setCurrentStep,
  currentStep,
  getValues,
}) {
  useEffect(() => {
    setValue("amount", Number(selected?.modalPremiumAmountTotal).toFixed(2));
  }, [selected]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [error, setError] = useState();
  const [checkboxState, setCheckboxState] = useState(false);
  const { t } = useTranslation();

  const onSubmit = () => {
    if (currentStep <= 3) setCurrentStep(3);
  };

  return (
    <>
      {selected && (
        <div className="ui-form-card-no-event">
          <RadioGroup
            className="ui-form-card-row"
            name="panelOneSelection"
            value={panelTwoSelection}
            onChange={setPanelTwoSelection}
          >
            {!isOldAlicUlPolicy(selected) ? (
              <RadioGroup.Option
                id="ID_paymentStep1Option1"
                className={({ checked }) =>
                  `${
                    checked && checkboxState
                      ? "ui-form-card selected"
                      : "ui-form-card"
                  }  `
                }
                {...register("amount")}
                tabIndex="0"
                aria-label="Select to pay this policy"
                aria-controls="ID_paymentStep2Options"
                aria-expanded="false"
                disabled={
                  parseFloat(selected?.modalPremiumAmountTotal) <= 0 ||
                  !selected?.modalPremiumAmountTotal
                }
                onClick={(e) => {
                  setCheckboxState(true);
                  setValue("amount", selected?.modalPremiumAmountTotal);
                  onSubmit();
                }}
              >
                {({ checked }) => (
                  <>
                    <RadioGroup.Label
                      className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                      as="p"
                    >
                      {t("AgentPaymentAmount-PremiumAmount")}
                    </RadioGroup.Label>
                    <RadioGroup.Label className="block text-black">
                      {stringFormattingToCurrency(
                        selected?.modalPremiumAmountTotal
                      )}
                    </RadioGroup.Label>
                    {/* <RadioGroup.Label className="text-xxs">
                    (Monthly)
                  </RadioGroup.Label> */}
                    <div className="text-xxs font-semibold pr-8 group-hover:underline">
                      <div className="ui-form-card-checkbox">
                        <svg
                          className="ui-icon w-2 h-2 text-white hidden"
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-checkmark"></use>
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            ) : (
              <RadioGroup.Option
                id="ID_paymentStep1Option1"
                className={({ checked }) =>
                  `${
                    checked && checkboxState
                      ? "ui-form-card selected"
                      : "ui-form-card"
                  }  `
                }
                {...register("amount")}
                tabIndex="0"
                aria-label="Select to pay this policy"
                aria-controls="ID_paymentStep2Options"
                aria-expanded="false"
                disabled={isDisabled}
                onClick={() => {
                  if (!isNaN(getValues("amount")) && getValues("amount") > 0) {
                    setCheckboxState(true);
                    setValue("amount", getValues("amount"));
                    setError(undefined);
                    setIsDisabled(false);
                    onSubmit();
                  } else {
                    console.log("checked");
                    setCheckboxState(false);
                    setIsDisabled(true);
                    setCurrentStep(2);
                    setError(t("AgentMakeAPayment-required-error"));
                  }
                }}
              >
                {({ checked }) => (
                  <>
                    <RadioGroup.Label
                      className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                      as="p"
                    >
                      {t("AgentPaymentAmount-ul-PremiumAmount")}
                    </RadioGroup.Label>
                    <RadioGroup.Label className="block text-black pr-4 ">
                      <div className="relative">
                        <input
                          id="paymentAmtId"
                          className="border border-ui-gray-medium h-9 w-full p-2 pl-8 top-1/2 rounded"
                          aria-labelledby={"old-alic-label"}
                          placeholder="Please enter pay amount"
                          onChange={(e) => {
                            if (isNaN(e.target.value)) {
                              setCurrentStep(2);
                              setError(t("AgentMakeAPayment-required-error"));
                            } else {
                              if (e.target.value > 0) {
                                setValue("amount", e.target.value);
                                setError(undefined);
                                setIsDisabled(false);
                              } else {
                                setCheckboxState(false);
                                setCurrentStep(2);
                                setError(t("AgentMakeAPayment-required-error"));
                                setIsDisabled(true);
                              }
                            }
                          }}
                        />
                        <svg
                          className="absolute text-theme-action top-1/2 mt-[-10px] ml-2"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <use href="#ui-icon-dollar"></use>
                        </svg>
                      </div>
                      <FormInputError id="id_amount" errorMessage={error} />
                    </RadioGroup.Label>
                    <RadioGroup.Label
                      className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                      as="p"
                    >
                      {t("AgentMakeAPayment-step2-sub-title")}
                    </RadioGroup.Label>
                    <div className="text-xxs font-semibold pr-8 group-hover:underline">
                      <div className="ui-form-card-checkbox">
                        <svg
                          className="ui-icon w-2 h-2 text-white hidden"
                          focusable="false"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <use href="#ui-icon-checkmark"></use>
                        </svg>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            )}
          </RadioGroup>
        </div>
      )}
    </>
  );
}
